import React from 'react';

interface AdminHeaderProps {
  totalGuests: number;
  filteredGuests: number;
  isFiltered: boolean;
  onLogout: () => void;
}

const AdminHeader: React.FC<AdminHeaderProps> = ({
  totalGuests,
  filteredGuests,
  isFiltered,
  onLogout,
}) => {
  return (
    <header className="modern-header">
      <div className="header-content">
        <div>
          <h1>Gestion des invités</h1>
          <p className="header-subtitle">
            {isFiltered
              ? `${filteredGuests} invité${filteredGuests > 1 ? 's' : ''} pour cet événement`
              : `${totalGuests} invités au total`}
          </p>
        </div>
        <button onClick={onLogout} className="modern-btn secondary">Déconnexion</button>
      </div>
    </header>
  );
};

export default AdminHeader;
